import axios from 'axios';

// --- Endorsements ---

export function getEndorsements(baseUrl, id, resourceType,  authToken) {
  return axios.get(`${baseUrl}endorsements/count/${resourceType}/${id}`, {
    headers: {
      ...(authToken && { Authorization: `Bearer ${authToken}` }),
    },
  });
}


export function getUserEndorsement(baseUrl, id, resourceType, authToken) {
  return axios.get(`${baseUrl}endorsements/${resourceType}/${id}`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
}

export function postEndorsement(baseUrl, id, value, resourceType, authToken) {
  return axios.post(`${baseUrl}endorsements`, {
    id: id,
    type: resourceType,
    value,
  }, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
}

export function editEndorsement(baseUrl, endorsementId, value, authToken) {
  return axios.put(`${baseUrl}endorsements/${endorsementId}`, {
    value,
  }, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
}

export function deleteEndorsement(baseUrl, endorsementId, authToken) {
  return axios.delete(`${baseUrl}endorsements/${endorsementId}`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
}

// --- Comments ---

export function getComments(baseUrl, datasetID, authToken) {
  return axios.get(`${baseUrl}comments/dataset/${datasetID}`, {
    headers: {
      ...(authToken && { Authorization: `Bearer ${authToken}` }),
    },
  });
}

export function sendComment(baseUrl, datasetID, content, locale, authToken, parent = null) {
  return axios.post(`${baseUrl}comments`, {
    id: datasetID,
    type: "dataset",
    content,
    lang: locale || "en",
    parent: parent,
  }, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
}

export function editComment(baseUrl, commentId, newContent, locale, authToken) {
  return axios.put(`${baseUrl}comments/${commentId}`, {
    content: newContent,
    lang: locale || "en",
  }, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
}

export function deleteComment(baseUrl, commentId, authToken) {
  return axios.delete(`${baseUrl}comments/${commentId}`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
}

export function publishComment(baseUrl, commentId, authToken) {
  return axios.post(`${baseUrl}comments/${commentId}/publish`, {}, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
}

export function unpublishComment(baseUrl, commentId, authToken) {
  return axios.post(`${baseUrl}comments/${commentId}/unpublish`, {}, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
}

// for moderation page
export function getAllComments(baseUrl, authToken, status = 'unpublished', limit = '10', offset = '0') {
  return axios.get(`${baseUrl}comments/all?status=${status}&limit=${limit}&offset=${offset}`, {
      headers: {
        ...(authToken && { Authorization: `Bearer ${authToken}` }),
      },
    })
}

export function reportComment(baseUrl, commentId, authToken) {
  return axios.post(`${baseUrl}comments/${commentId}/report`, {
    // "reason": ""
  }, {
      headers: {
        ...(authToken && { Authorization: `Bearer ${authToken}` }),
      },
    })
}

export function withdrawReport(baseUrl, commentId, authToken) {
  return axios.delete(`${baseUrl}comments/${commentId}/report`, {
      headers: {
        ...(authToken && { Authorization: `Bearer ${authToken}` }),
      },
    })
}

export async function getDataset(baseUrl, id) {
  try {
    const response = await axios.get(`${baseUrl}datasets/${id}`);

    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Status:", error.response.status);
      console.error("Data:", error.response.data);
    } else if (error.request) {
      console.error("No response received:", error.request);
    } else {
      console.error("Error message:", error.message);
    }

    return null;
  }
}

export async function getMostLike(baseUrl, sort, limit, offset) {
  try {
    const response = await axios.get(`${baseUrl}/resources/dataset`, {
      params: {
        sort,
        limit,
        offset,
      }
    });

    return response.data;
  } catch (error) {
    console.error("Error retrieving Most Liked:", error.response?.data || error.message);
    throw error;
  }
}
